import React, { useEffect, useState, useMemo } from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import { useTextResources } from '../../../language'
import { Form } from 'semantic-ui-react'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetOccupancyForecastData } from '../../../api/services/pms';
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import PropTypes from 'prop-types'
import { GetHotels } from '../../../api/services/organization'
import { onError } from '../../shared/messages'
import { dateFormat, dateFormatShort } from '../../shared/constants'

const OccupancyForecastReport = ({ HotelID }) => {
    const text = useTextResources()
    const [searchState, setSearchState] = useState({})
    const [data, setData] = useState([])
    const [hotels, setHotels] = useState([])
    const days = 10


    useEffect(() => {
        (async () => {
            try {
                const hotels = await GetHotels()
                setHotels(hotels)
            } catch (error) {
                onError(error)
            }
        })()
    }, [HotelID])

    const onSearchChange = (search) => {
        search.EndDate = moment(search.StartDate).add(days, "days").toISOString();
        setSearchState(search)
    }

    const onSearchComplete = (data, searchState) => {
        setSearchState(searchState)
        const groups = {
            "Comments": text("Comments"),
            "Rooms": text("Rooms"),
            "Occupancy": text("Rooms"),
            "OccupiedPreviousDay": text("Rooms"),
            "Departures": text("Departures"),
            "LocalDepartures": text("Departures"),
            "TouristDepartures": text("Departures"),
            "Arrivals": text("Arrivals"),
            "LocalArivals": text("Arrivals"),
            "TouristArrivals": text("Arrivals"),
            "Occupied": text("Occupied"),
            "LocalRoomNight": text("Occupied"),
            "TouristRoomNight": text("Occupied"),
            "Vacant": text("Vacant"),
            "Adults": text("Guests"),
            "Children": text("Guests"),
            "Infants": text("Guests"),
            "Guests": text("Guests"),
            "Meals": text("Meals"),
            "Individuals": text("Individuals")
        }
        const rows = ["Comments", "Rooms", "Occupancy", "OccupiedPreviousDay", "Departures", "LocalDepartures", "TouristDepartures", "Arrivals", "LocalArivals", "TouristArrivals", "Occupied", "LocalRoomNight", "TouristRoomNight", "Vacant", "Adults", "Children", "Infants", "Guests", "Meals", "Individuals"]
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        var mealData = []
        let newData = rows.map(row => {
            let newRow = {
                "Description": text(row),
                "ID": row,
                "Group": groups[row]
            }
            for (let date of range.by("day")) {
                const getReservationDailyAccommodations = (_reservation) => _reservation.ReservationDailyAccommodations.find(obj => moment(obj.Date).isSame(date.clone(), "day"));
                var currentAvailable = data.availability.filter(obj => moment(obj.Date).isSame(date.clone(), "day"));
                var previousAvailable = data.availability.filter(obj => moment(obj.Date).isSame(date.clone().subtract(1, "days"), "day"));
                var departureReservations = data.reservations.filter(obj => moment(obj.CheckOutDate).isSame(date.clone(), "day"));
                var arivalReservations = data.reservations.filter(obj => moment(obj.CheckInDate).isSame(date.clone(), "day"));
                var rangeOfOccuipedReservations = data.reservations.filter(obj => moment(obj.CheckInDate).isSameOrBefore(date, 'day') && moment(obj.CheckOutDate).isAfter(date, 'day'))
                var localRoomNight = rangeOfOccuipedReservations.filter(r => r.Guest.Nationality?.CountryID === data.hotels[0].Location?.Country?.Id).length
                var toiristRoomNight = rangeOfOccuipedReservations.filter(r => !r.Guest.Nationality || r.Guest.Nationality.CountryID !== data.hotels[0].Location?.Country?.Id).length
                var occuiped = localRoomNight + toiristRoomNight
                var hotelParameters = data.hotelDateParameters.filter(obj => moment(obj.Date).isSame(date.clone(), "day"));
                var rangeReservations = data.reservations.filter(obj => date.isBetween(moment(obj.CheckInDate).startOf("day"), moment(obj.CheckOutDate).startOf("day"), undefined, '[]'))
                var meals = rangeReservations.map(reservation => reservation.ReservationDailyAddons.filter(obj => moment(obj.ConsumptionDate).isSame(date.clone(), "day") && obj.HotelAddon.ChainAddon.TypeID == 2)).flat().reduce((initalValue, addon) => initalValue + addon.AdultQuantity + addon.ChildQuantity, 0);
                let localReservations = rangeReservations.filter(r => r.Guest.Nationality?.CountryID === data.hotels[0].Location?.Country?.Id)
                let touristReservations = rangeReservations.filter(r => !r.Guest.Nationality || r.Guest.Nationality.CountryID !== data.hotels[0].Location?.Country?.Id)
                let totalAvailble = currentAvailable.reduce((initialValue, item) => initialValue + item.Available, 0);
                let totalGrossInventory = currentAvailable.reduce((initialValue, item) => initialValue + item.GrossInventory, 0);
                let totalGuests =
                    data.reservations.reduce((initialValue, reservation) => {
                        const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                        if (reservationDailyAccommodations) {
                            return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                        }
                        else {
                            return localReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0) + touristReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0)
                        }
                    }, 0)
                switch (row) {
                    case 'Comments':
                        newRow[date.format(dateFormat)] = hotelParameters[0].CalendarEvent?.Name
                        newRow["ParentId"] = null
                        break;
                    case 'Rooms':
                        newRow[date.format(dateFormat)] = totalGrossInventory - totalAvailble
                        newRow["ParentId"] = null
                        break;
                    case 'Occupancy':
                        if (currentAvailable.length == 0) {
                            newRow[date.format(dateFormat)] = "0%"
                        } else {
                            newRow[date.format(dateFormat)] = ((1 - (totalAvailble / totalGrossInventory).toFixed(2)) * 100).toFixed(0) + "%"
                        }
                        newRow["ParentId"] = "Rooms"
                        break;
                    case 'OccupiedPreviousDay':
                        newRow[date.format(dateFormat)] = previousAvailable.reduce((initialValue, item) => initialValue + item.Sold, 0)
                        newRow["ParentId"] = "Rooms"
                        break;
                    case 'Departures':
                        newRow[date.format(dateFormat)] = departureReservations.length
                        newRow["ParentId"] = "Rooms"
                        break;
                    case 'LocalDepartures':
                        newRow[date.format(dateFormat)] = departureReservations.filter((r => r.Guest.Nationality?.CountryID === data.hotels[0].Location?.Country?.Id)).length
                        newRow["ParentId"] = "Departures"
                        break;
                    case 'TouristDepartures':
                        newRow[date.format(dateFormat)] = departureReservations.filter((r => !r.Guest.Nationality || r.Guest.Nationality.CountryID !== data.hotels[0].Location?.Country?.Id)).length
                        newRow["ParentId"] = "Departures"
                        break;
                    case 'Arrivals':
                        newRow[date.format(dateFormat)] = arivalReservations.length
                        newRow["ParentId"] = "Rooms"
                        break;
                    case 'LocalArivals':
                        newRow[date.format(dateFormat)] = arivalReservations.filter((r => r.Guest.Nationality?.CountryID === data.hotels[0].Location?.Country?.Id)).length
                        newRow["ParentId"] = "Arrivals"
                        break;
                    case 'TouristArrivals':
                        newRow[date.format(dateFormat)] = arivalReservations.filter((r => !r.Guest.Nationality || r.Guest.Nationality.CountryID !== data.hotels[0].Location?.Country?.Id)).length
                        newRow["ParentId"] = "Arrivals"
                        break;
                    case 'Occupied':
                        newRow[date.format(dateFormat)] = occuiped
                        newRow["ParentId"] = "Rooms"
                        break;
                    case 'LocalRoomNight':
                        newRow[date.format(dateFormat)] = localRoomNight
                        newRow["ParentId"] = "Occupied"
                        break;
                    case 'TouristRoomNight':
                        newRow[date.format(dateFormat)] = toiristRoomNight
                        newRow["ParentId"] = "Occupied"
                        break;
                    case 'Vacant':
                        newRow[date.format(dateFormat)] = currentAvailable.reduce((initialValue, item) => initialValue + item.Available, 0)
                        newRow["ParentId"] = "Rooms"
                        break;
                    case 'Guests':
                        newRow[date.format(dateFormat)] = totalGuests
                        newRow["ParentId"] = null
                        break;
                    case 'Adults':
                        newRow[date.format(dateFormat)] =
                            data.reservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Adults, 0) + touristReservations.reduce((initialValue, item) => initialValue + item.Adults, 0)
                                }
                            }, 0)
                        newRow["ParentId"] = "Guests"
                        break;
                    case 'Children':
                        newRow[date.format(dateFormat)] =
                            data.reservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Children
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Children, 0) + touristReservations.reduce((initialValue, item) => initialValue + item.Children, 0)
                                }
                            }, 0)
                        newRow["ParentId"] = "Guests"
                        break;
                    case 'Infants':
                        newRow[date.format(dateFormat)] =
                            data.reservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Infants
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Infants, 0) + touristReservations.reduce((initialValue, item) => initialValue + item.Infants, 0)
                                }
                            }, 0)
                        newRow["ParentId"] = "Guests"
                        break;
                    case 'Meals':
                        newRow["ParentId"] = null
                        newRow[date.format(dateFormat)] = meals;
                        break;
                    case 'Individuals':
                        if (occuiped == 0 || totalGuests == 0) {
                            newRow[date.format(dateFormat)] = 0
                        }
                        else {
                            newRow[date.format(dateFormat)] = occuiped + "/" + totalGuests
                        }
                        newRow["ParentId"] = null
                        break;
                }
            }
            return newRow

        })
        setData([...newData, ...mealData])
    }

    const formatter = ({ value }) => {
        return <div style={{ fontSize: '1.2rem' }}>{value}</div>
    }
    const columns = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumns = Array.from(range.by("day")).map(day => {
            return {
                name: day.format(dateFormat),
                title: day.format(dateFormatShort),
                formatter
            }
        })
        return [
            { name: 'Description', title: text('Description'), formatter },
            { name: 'Group', title: text('Group') },
            ...dateColumns
        ]
    }, [searchState.StartDate])


    const columnExtensions = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumnExtensions = Array.from(range.by("day")).map(day => {
            return {
                columnName: day.format(dateFormat),
                width: 135
            }
        })
        return [
            ...dateColumnExtensions
        ]
    }, [searchState.StartDate])


    const customizeExcelHeader = worksheet => {
        const hotel = hotels.find(x => x.Id === HotelID)
        const row = worksheet.addRow([`${text("OccupancyForecastReport")} ${hotel && hotel.Name}, ${moment(searchState.StartDate).format(dateFormat)} - ${moment(searchState.StartDate).add(days, "days").format(dateFormat)}`])
        worksheet.mergeCells('A1:O1');
        row.height = 20
        row.font = { bold: true, size: 16 };
    }


    const gridOptions = useMemo(() => {
        return {
            search: {
                title: text("OccupancyForecastReport"),
                fields: [
                    <Form.Field control={HotelsDropDown} width="4" label={text("Hotel")} key="HotelID" />,
                    <DatePicker
                        clearable={false}
                        type="basic"
                        label={text("StartDate")}
                        name="StartDate"
                        key="StartDate"
                    />
                ],
                initial: {
                    "HotelID": HotelID,
                    StartDate: moment().startOf("day").toDate()
                },
                api: GetOccupancyForecastData,
                groupSize: 6
            },
            grid: {
                columns: columns,
                tree: {
                    defaultExpandedRows: [],
                    getChildRows: (row, rootRows) => {
                        const childRows = rootRows.filter(r => r.ParentId === (row ? row.Id : null));
                        return childRows.length ? childRows : null;
                    },
                    treeColumnName: "Description"
                },
                customOptions: {
                    hidden: {
                        hiddenColumns: [{ columnName: 'Group' }]
                    }
                },
                summary: true,
                export: true,
                pdf: true,
                columnExtensions: columnExtensions,
                excel: {
                    customizeHeader: customizeExcelHeader,
                    grouping: [{ columnName: "Group" }],
                    totalSummaryItems: [
                        { columnName: "Group", type: 'sum' }
                    ],
                },
            }
        }
    }, [data])

    return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} onSearchChange={onSearchChange} data={data} />)
}
OccupancyForecastReport.propTypes = {
    HotelID: PropTypes.any
}
export default OccupancyForecastReport